import clientAuth from "../clientAuth";

export default {
  index: () => clientAuth.get("kitchen/index"),
  
  store: (userData) => clientAuth.post('kitchen/store', { json: userData }),
  

  show:(id)=>clientAuth.get('kitchen/show/'+id),

  update:(id,userData)=>clientAuth.post('kitchen/update/'+id,{json:userData}),

  destroy:(id)=>clientAuth.delete(`kitchen/destroy/${id}`),
};